import AHttpService from '@d-services/a-http-service/a-http-service';
import URLS from '@d-shared/urls/urls';

class BookInformationService extends AHttpService {
  async getBookInfoFromUrl(bookUrl) {
    const url = URLS.api.booksByUrl.replace('<book-url>', bookUrl);
    try {
      const response = await this._http.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new BookInformationService();
